export const ColorHexCodes = {
  Main: "0583b8",
  SubHeader: "2a5298",
  GeneralRed: "fb6754",
  GeneralDarkRed: "bf3422",
  GeneralBlue: "719ac5",
  GridGray: "d0d2db",
  ActiveCharBlue: "29abe2",
  White: "FFFFFF",
  Black: "000000",
  Red: "ffcfc9",
  Orange: "ffe1c9",
  Yellow: "fcf5d4",
  Green: "ccefc9",
  Cyan: "c0eee6",
  Blue: "c0e2ee",
  Purple: "ddd1e6",
  Magenta: "edd6e5",
  SubRed: "fb6754",
  SubBlue: "1d96d5",
  PagenationGray: "eeeeee",
  SubBackground: "eaedf8",
  SubList: "ecf1f7",
  Sub: "73d7ff",
  DeepRed: "ed1c24",
  CellGray: "dfefee",
  DisabledBackground: "ebedef",
  ActiveGreen: "0ca285"
};

export type Color = keyof typeof ColorHexCodes;

export const getHexCode = (color: Color) => {
  return `#${ColorHexCodes[color] ?? ""}`;
};
